import store from '../store/index'

export default class lang {
    static getLang () {
        let url = window.location.href
        let lang = 'en'
        let langDocument = document.getElementById("wacg-wrapper").getAttribute("data-lang");

        if (langDocument) {
            lang = langDocument;
        }

        if (url.includes('/ar') || url.includes('ar.') || url.includes('ar-eg')) {
            lang = 'ar'
        }


        store.dispatch('setLang', lang)
        return lang
    }
}




// import i18n from "../i18n";
// import vuetify from "../plugins/vuetify";
// import {http} from "../plugins/axios";
//
//
//
// setInterval(()=>{
//     console.log(window.location.href)
//     newLang = getLang()
//     if (lang !== newLang) {
//         i18n.locale = newLang
//         vuetify.rtl = store.state.core.lang === 'ar'
//         http.headers = {
//             "Accept-Language": `${newLang}`,
//         }
//         store.dispatch('setLang', newLang)
//         lang = newLang
//     }
//
// }, 3000);
